import { connect } from 'react-redux'
import CandidateMetrics from 'modules/CandidateMetrics/index'

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CandidateMetrics)
